import { FlareDataSchema } from '@common/flare-data/schemas/flare-data-schema';
import { FlareDataXmlSerializer } from '@common/flare-data/util/flare-data-xml-serializer';
import { NodeType } from '@common/html/enums/node-type.enum';
import { SimpleDomDocument, SimpleDomNode } from '@common/html/simple-dom/node';
import { Serializer } from '@common/prosemirror/model/serializer';

/** Base prosemirror document schema for Flare data xml formats (such as targets, variables, conditions, toc...). */
export abstract class FlareDataXmlSchema extends FlareDataSchema {

  private _serializer = new FlareDataXmlSerializer();

  get serializer(): Serializer { return this._serializer; }
  get validateDoc() { return this.validateXmlDoc; }

  /** Gets the function to validate xml document formed from code. */
  abstract validateXmlDoc(xmlDoc: SimpleDomDocument);

  protected validateRootElement(xmlDoc: SimpleDomDocument, rootTagName: string): void {
    let rootElement: SimpleDomNode;

    const rootChildren = xmlDoc.children;
    rootChildren.forEach(child => {
      if (child.nodeType === NodeType.ELEMENT_NODE && child.nodeName !== 'flareDataComment') {
        if (rootElement)
          throw new Error(`Document must have only one root tag`);
        rootElement = child;
      }
    });

    if (!rootElement)
      throw new Error(`Root tag of document is missing`);

    if (rootElement.nodeName !== rootTagName)
      throw new Error(`Incorrect root element name: '${rootTagName}' is expected, '${rootElement.nodeName}' is found.`);
  }

}
